import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {getDatabase, ref, onValue} from "firebase/database";

import {Flex} from "reflexbox";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import CardContainer from "./courseContentDisplays/CardContainer";
import AlertDialog from "./common/AlertDialog";
import {courses} from "./courseContent/courseObjects";


const CoursePayment = (props) => {
  let navigate = useNavigate();
  const {course} = useParams();
  const uid = useSelector((state) => state.user?.uid);
  const [paid, setPaid] = useState(false);
  const currentCourseName = course || null;

  const paymentURL = courses[currentCourseName].paymentLink;

  useEffect(() => {
    const db = getDatabase();
    //const dbRef = ref(db);
    const paymentsRef = ref(db, `payments/${uid}`);
    onValue(paymentsRef, (snapshot) => {
      const data = snapshot.val();
      if (data?.paidAt) {
        setPaid(true);
      }
    });
  }, [uid]);

  const handleContinue = () => {
    navigate(props.nextURL);
  };

  return (<>
    <CardContainer
      alternateHeader
      cardContent1={(
        <Flex style={{flexDirection: 'column'}}>
          <Typography variant={'h6'} style={{fontWeight: 'bold'}}>End of Free Trial</Typography>
          <Typography>We hope you continue the course! Your purchase helps us cover costs and make the game
            better.</Typography>
          <a href={paymentURL} target="_blank" rel="noreferrer" style={{textDecoration: 'none', width: '100%'}}>
            < Button variant={'contained'} color={'primary'}
                     style={{margin: '16px 0px', width: '100%'}}>Buy Course ($5)</Button>
          </a>
          <Typography variant="caption" color="text.secondary">You'll be redirected out of our app to our
            payment provider website (checkout.stripe.com)</Typography>
          <hr/>
          <Typography style={{marginTop: '16px', fontWeight: 'bold'}}>Buying a course lets you:</Typography>
          <ul>
            <li><Typography>Explore more locations</Typography></li>
            <li><Typography>Solve more questions</Typography></li>
            <li><Typography>See how your team compares against others on the leaderboard</Typography></li>
          </ul>
        </Flex>
      )}/>
      <AlertDialog open={paid} close={handleContinue} disableCancel hideContinue body={(<>
        <Typography variant={'h6'} style={{fontWeight: 'bold'}}>Payment received successfully! </Typography>
        <Typography>Thank you for supporting Capital Clues. </Typography>
        <Button variant={'contained'} color={'primary'}
                style={{margin: '16px 0px', width: '100%'}}
                onClick={handleContinue}> Continue course </Button>
        </>)
      }/>
  </>)
};

export default CoursePayment;